var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNeuraTalkIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_10821",
  "data-name": "Group 10821",
  transform: "translate(1770 -5637)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_3047",
  "data-name": "Rectangle 3047",
  width: 16,
  height: 16,
  transform: "translate(-1770 5637)",
  fill: "#ff686e",
  opacity: 0
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_10819",
  "data-name": "Group 10819",
  transform: "translate(-1758.835 5636.953)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3065",
  "data-name": "Path 3065",
  d: "M2.442,3.881a.2.2,0,0,1-.189-.143v0l-.207-.8a.131.131,0,0,0-.094-.094l-.8-.207h0a.2.2,0,0,1,0-.378h0l.8-.207a.131.131,0,0,0,.094-.094l.207-.8v0a.2.2,0,0,1,.378,0v0l.207.8a.131.131,0,0,0,.094.094l.8.207h0a.2.2,0,0,1,0,.379h0l-.8.207a.131.131,0,0,0-.094.094l-.207.8v0A.2.2,0,0,1,2.442,3.881Z",
  fill: "#ff686e"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3066",
  "data-name": "Path 3066",
  d: "M19.131,2.786A.131.131,0,0,1,19,2.655V2.131a.131.131,0,1,1,.262,0v.524A.131.131,0,0,1,19.131,2.786Z",
  transform: "translate(-15.642 -0.869)",
  fill: "#ff686e"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3067",
  "data-name": "Path 3067",
  d: "M17.655,4.262h-.524a.131.131,0,1,1,0-.262h.524a.131.131,0,0,1,0,.262Z",
  transform: "translate(-13.904 -2.607)",
  fill: "#ff686e"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_10820",
  "data-name": "Group 10820",
  transform: "translate(-1770.048 5636.952)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3070",
  "data-name": "Path 3070",
  d: "M10.2,4.844A.641.641,0,0,1,9.563,4.2V2.281H7.641A.641.641,0,0,1,7.641,1H10.2a.641.641,0,0,1,.641.641V4.2A.641.641,0,0,1,10.2,4.844Z",
  transform: "translate(-2.156)",
  fill: "#ff686e"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3071",
  "data-name": "Path 3071",
  d: "M3.641,16.533A.641.641,0,0,1,3,15.892V6.922A1.924,1.924,0,0,1,4.922,5h7.689a1.924,1.924,0,0,1,1.922,1.922v5.126a1.924,1.924,0,0,1-1.922,1.922H6.469L4.094,16.345A.641.641,0,0,1,3.641,16.533ZM4.922,6.281a.641.641,0,0,0-.641.641v7.423l1.469-1.469a.641.641,0,0,1,.453-.188h6.407a.641.641,0,0,0,.641-.641V6.922a.641.641,0,0,0-.641-.641Z",
  transform: "translate(-0.719 -1.437)",
  fill: "#ff686e"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3072",
  "data-name": "Path 3072",
  d: "M2.922,12.281H1.641a.641.641,0,0,1,0-1.281H2.922a.641.641,0,0,1,0,1.281Z",
  transform: "translate(0 -3.593)",
  fill: "#ff686e"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3073",
  "data-name": "Path 3073",
  d: "M8.641,12.563A.641.641,0,0,1,8,11.922V10.641a.641.641,0,0,1,1.281,0v1.281A.641.641,0,0,1,8.641,12.563Z",
  transform: "translate(-2.515 -3.234)",
  fill: "#ff686e"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3074",
  "data-name": "Path 3074",
  d: "M14.641,12.563A.641.641,0,0,1,14,11.922V10.641a.641.641,0,0,1,1.281,0v1.281A.641.641,0,0,1,14.641,12.563Z",
  transform: "translate(-4.671 -3.234)",
  fill: "#ff686e"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3075",
  "data-name": "Path 3075",
  d: "M20.922,12.281H19.641a.641.641,0,0,1,0-1.281h1.281a.641.641,0,1,1,0,1.281Z",
  transform: "translate(-6.467 -3.593)",
  fill: "#ff686e"
})))));
export { SvgNeuraTalkIcon as ReactComponent };
export default __webpack_public_path__ + "static/media/NeuraTalkIcon.610bac68d153b3f935435e8770ff030e.svg";